"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accessForExternalUser = void 0;
var joi_1 = __importDefault(require("joi"));
var constants_1 = require("@hobt/constants");
var accessRole = joi_1.default.object({
    activeFlag: joi_1.default.boolean().required(),
    roleCode: joi_1.default.number().when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.Internal,
        then: joi_1.default.when('activeFlag', {
            is: true,
            then: joi_1.default.valid(
            // internal roles only
            constants_1.UserRole.CmhcAdministrator, constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly, constants_1.UserRole.PortfolioAnalyst).required(),
            otherwise: joi_1.default.forbidden(),
        }),
        otherwise: joi_1.default.forbidden(),
    }),
});
var claimAccessRole = joi_1.default.object({
    activeFlag: joi_1.default.boolean().required(),
    roleCode: joi_1.default.number().when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.Internal,
        then: joi_1.default.when('activeFlag', {
            is: true,
            then: joi_1.default.valid(
            // internal roles only
            constants_1.UserRole.CmhcAdministrator, constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly).required(),
            otherwise: joi_1.default.forbidden(),
        }),
        otherwise: joi_1.default.forbidden(),
    }),
    inventoryViewTypeCode: joi_1.default.number().when('activeFlag', {
        is: true,
        then: joi_1.default.valid.apply(joi_1.default, Object.values(constants_1.ClaimInventoryViewType)).required(),
        otherwise: joi_1.default.valid.apply(joi_1.default, Object.values(constants_1.ClaimInventoryViewType)).optional(),
    }),
    probationaryUserFlag: joi_1.default.boolean().when(joi_1.default.ref('/userTypeCode'), {
        is: constants_1.UserType.Internal,
        then: joi_1.default.when('activeFlag', {
            is: true,
            then: joi_1.default.when('roleCode', {
                is: constants_1.UserRole.BusinessUser,
                then: joi_1.default.boolean().required(),
                otherwise: joi_1.default.boolean().optional(),
            }),
            otherwise: joi_1.default.boolean().optional(),
        }),
        otherwise: joi_1.default.forbidden(),
    }),
});
var accessRoleActiveRequired = accessRole.keys({
    activeFlag: joi_1.default.boolean()
        .required()
        .invalid(false),
});
var claimRoleActiveRequired = claimAccessRole.keys({
    activeFlag: joi_1.default.boolean()
        .required()
        .invalid(false),
});
exports.accessForExternalUser = joi_1.default.alternatives().conditional(joi_1.default.object({
    admin: { activeFlag: false },
    arrears: { activeFlag: false },
    claim: { activeFlag: false },
    default: { activeFlag: false },
    piFileShare: { activeFlag: false },
    piPurposeTest: { activeFlag: false },
    piRequest: { activeFlag: false },
}).unknown(), {
    then: joi_1.default.object({
        admin: accessRoleActiveRequired.required(),
        arrears: accessRoleActiveRequired.required(),
        claim: claimRoleActiveRequired.required(),
        default: accessRoleActiveRequired.required(),
        piFileShare: accessRoleActiveRequired.required(),
        piPurposeTest: accessRoleActiveRequired.required(),
        piRequest: accessRoleActiveRequired.required(),
    }),
    otherwise: joi_1.default.object({
        admin: accessRole.required(),
        arrears: accessRole.required(),
        claim: claimAccessRole.required(),
        default: accessRole.required(),
        piFileShare: accessRole.required(),
        piPurposeTest: accessRole.required(),
        piRequest: accessRole.required(),
    }),
});
